import { put, call, take, fork } from 'redux-saga/effects'
import { courseCreationProgressService } from 'src/api/course'
import { GET_COURSE_CREATION_PROGRESS } from 'src/reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseCreationProgressFlow(payload) {
  try {
    const { id, callback } = payload
    const response = yield call(courseCreationProgressService, id)

    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseCreationProgressWatcher() {
  let task = null
  while (true) {
    const action = yield take(GET_COURSE_CREATION_PROGRESS)
    
    // Ignore new polling intervals if the previous request is still running
    if (task && task.isRunning()) {
      continue
    }

    const { payload } = action

    task = yield fork(generalSaga, courseCreationProgressFlow, payload, false)
  }
}
